import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import { FormattedMessage } from 'react-intl'
import Tooltip, { POSITION, ALIGN } from 'gnos-tooltip'
import cx from 'classnames'

import { LOCALE_PREFIX } from '../../../../constants'

import './style.scss'

export default class MultipleEntitiesContentButton extends Component {
    static propTypes = {
        group: IPropTypes.map,
        handleAddToGroup: PropTypes.func.isRequired,
        index: PropTypes.number.isRequired,
        loading: PropTypes.bool,
    }

    handleBtnClick = () => {
        const { handleAddToGroup, group, index } = this.props

        const groupId = group.get('id', null)

        if (!groupId) return null

        handleAddToGroup(groupId, index)
        return null
    }

    render() {
        const { index, loading } = this.props

        return (
            <div className={'me-content-btn'}>
                <Tooltip
                    id={`manage-group-add-btn-tooltip-${index}`}
                    content={<FormattedMessage id={`${LOCALE_PREFIX}.addBtnTooltip`} />}
                    position={POSITION.TOP}
                    align={ALIGN.CENTER}
                >
                    <button
                        className={cx('group-control-btn', 'add', loading && 'loading')}
                        onClick={this.handleBtnClick}
                    />
                </Tooltip>
            </div>
        )
    }
}
